export default __webpack_public_path__ + "static/media/week-12-img.91e41cc5.png";